export const Media = () => <span>Media dummy</span>;
